export default {
  urlFlag: "",

  projectName: "",
  currentPage: "",
  validateProjectName: false,
  validatePlatform: false,
  adminLink: "",
  websiteLink: "",
  plans: [],
  offerActivated: false,
  selectedPlan: "",
  platforms: [],
  suites: [],
  selectedSuiteData: {},
  selectedSuitesQuestion: [],
  verifyFeature: false,
  verifiedFeature: false,
  additionalFeature: "",
  resellerLead: false,
  recommendations: [],
  completePercentage: "",
  // project pages
  enteredName: "",
  enteredEmail: "",
  enteredNumber: "",
  userDetails: "",
  userToken: "",
  isCheckedOut: false,
  defaultPages: [],
  // to know user location for country code in projet register
  ipLocation: "",
};
